import {
  RPFileValidatorErrorMessages,
  RPFileValidatorSuccessMessage,
} from '../constants/AddAttachmentsRPConstants'
import { validateRPFileName, validateRPFileType } from './AddAttachmentsRPHelpers'

interface CommonValidationProps {
  fileName: string
  fileSize: number
  hasDuplicate: boolean
}

interface CommonValidationConfig {
  maximumFileSizeAllowed: number
  allowedFileTypes: string[]
}

export const AddAttachmentsRPFileValidatorHelper = {
  Common: (props: CommonValidationProps, config: CommonValidationConfig): string => {
    const errorList: string[] = []
    let validationMessage: string = ''

    if (props.fileSize >= config.maximumFileSizeAllowed)
      errorList.push(RPFileValidatorErrorMessages.FileIsTooBig)

    if (!validateRPFileType(props.fileName, config.allowedFileTypes))
      errorList.push(RPFileValidatorErrorMessages.FileTypeNotAllowed)

    if (!validateRPFileName(props.fileName))
      errorList.push(RPFileValidatorErrorMessages.FileNameIsInvalid)

    if (props.hasDuplicate) errorList.push(RPFileValidatorErrorMessages.FileDuplicateExists)

    if (errorList.length > 0) {
      errorList.push(RPFileValidatorErrorMessages.FileUploadOtherFile)
      validationMessage = errorList.join('. ')
    } else {
      validationMessage = RPFileValidatorSuccessMessage.FileUploadedReadyToLink
    }

    return validationMessage
  },
}
